module.exports = __webpack_public_path__ + "static/media/config_icon.ce3d0b65.svg";